import { PERSONA_IA_OPERACIONAL } from '@modules/aawz-intelligence-v2/constants/Personas'
import { reduzirEventos } from '@modules/aawz-intelligence-v2/utils/painel-deliberacao'
import { ID_SEM_MODELO } from '@modules/aawz-intelligence-v2/utils/modelos-suportados'
import { ordenarPorRecencia } from '@modules/aawz-intelligence-v2/utils/ordenar-conversas'
import { hubEAgenteGetters } from './hub-e-agente'

// ★ Ponto ÚNICO da ordem de "Recentes": mais recente (`updated_at`) primeiro.
// O servidor lista por `created_at` e o state fica assim — a paginação usa o
// TAMANHO da store como `offset`, e ordenar aqui não o muda. Lateral, popup,
// palette e `aiFramework` leem deste getter.
export const conversations = function (state) {
  return ordenarPorRecencia(state.conversations)
}
export const conversationsLoading = function (state) {
  return state.conversationsLoading
}
export const conversationsError = function (state) {
  return Boolean(state.conversationsError)
}
export const selectedConversation = function (state) {
  return state.selectedConversation
}

export const folders = function (state) {
  return state.folders || []
}
export const foldersLoading = function (state) {
  return state.foldersLoading
}
export const foldersLastUpdate = function (state) {
  return state.foldersLastUpdate
}
// Agrupa as conversas por id_folder → { [folderId]: Conversa[] }. Só conversas
// com id_folder não-nulo entram (as soltas ficam em `looseConversations`).
export const conversationsByFolder = function (state, getters) {
  const grouped = {}
  const list = getters.conversations
  for (const conv of list) {
    const folderId = conv && conv.id_folder
    if (!folderId) continue
    if (!grouped[folderId]) grouped[folderId] = []
    grouped[folderId].push(conv)
  }
  return grouped
}
// Conversas soltas (sem pasta) — id_folder null/ausente.
export const looseConversations = function (state, getters) {
  return getters.conversations.filter(function (conv) {
    return !(conv && conv.id_folder)
  })
}

export const messages = function (state) {
  return state.messages || []
}
export const messagesLoading = function (state) {
  return state.messagesLoading
}

export const chatLoading = function (state) {
  return state.chatLoading
}
export const responseTokens = function (state) {
  return state.responseTokens || []
}
export const thinkingSteps = function (state) {
  return state.thinkingSteps || []
}
export const toolCalls = function (state) {
  return state.toolCalls || []
}
export const pendingConfirmation = function (state) {
  return state.pendingConfirmation || null
}
export const isStreaming = function (state) {
  return state.chatLoading
}

export const promptSuggestions = function (state) {
  return state.promptSuggestions || []
}
export const promptSuggestionsLoading = function (state) {
  return state.promptSuggestionsLoading
}

export const personaMode = function (state) {
  return state.personaMode
}

export const persona = function (state) {
  return state.persona || PERSONA_IA_OPERACIONAL
}

// Vazio = ninguém publicou ainda (nenhuma superfície de navegação montada).
// Quem lê deve tratar isso como "não sei", e não como "nenhum agente".
export const agenteAtivoId = function (state) {
  return state.agenteAtivoId || ''
}

export const servicosCitadosStreaming = function (state) {
  return state.servicosCitadosStreaming || []
}

export const perguntasAoGestorStreaming = function (state) {
  return state.perguntasAoGestorStreaming || []
}

export const painelStreaming = function (state) {
  return state.painelStreaming || null
}

export const painelEventosStreaming = function (state) {
  return state.painelEventosStreaming || []
}

// A sala montada a partir dos eventos parciais. `null` enquanto nenhum evento
// chegou — é o que o componente usa para decidir se há sala a renderizar.
export const painelParcialStreaming = function (state) {
  return reduzirEventos(state.painelEventosStreaming || [])
}

// ★ Sem fallback literal (Q7-A08): vazio significa "a lista ainda não chegou",
// e quem envia o turno faz `selectedModel || null` — o backend aplica o padrão
// dele. Um id cravado aqui volta a mentir no dia em que ele sair da lista.
export const selectedModel = function (state) {
  return state.selectedModel || ID_SEM_MODELO
}

export const supportedModels = function (state) {
  return state.supportedModels || []
}

export const currentModelMeta = function (state) {
  const models = state.supportedModels || []
  const id = state.selectedModel
  for (const model of models) {
    if (model.id === id) return model
  }
  return null
}

// ---- Curadoria de sugestões da IA (spec-003/005/006) -----------------------

export const curadoriaGroups = function (state) {
  return state.curadoriaGroups || []
}
export const curadoriaSummary = function (state) {
  return state.curadoriaSummary || null
}
export const curadoriaLoading = function (state) {
  return state.curadoriaLoading
}

// spec-006 — grupos por status (default sempre válido, nunca undefined)
export const curadoriaPorStatus = function (state) {
  return state.curadoriaPorStatus || { aguardando: [], aceita: [], declinada: [] }
}

export const faseDoTurno = function (state) {
  return state.faseDoTurno || null
}

// ★ [review #2364, item D] `{no, estado}` do último `node-status`, ou `null`.
export const noDoTurno = function (state) {
  return state.noDoTurno || null
}

// ---- Modo Agente (spec-002-chat-agentico-estilo-claude-code, plan.md D13) --
// Nomes conferidos contra o consumidor real (`views/chat/view-chat.vue`).

export const runAtual = function (state) {
  return state.runAtual || null
}

export const propostasAbertas = function (state) {
  return state.propostasAbertas || {}
}

export const reconectando = function (state) {
  return Boolean(state.reconectando)
}

export const plano = function (state) {
  return state.plano || null
}

export const buscaStreaming = function (state) {
  return state.buscaStreaming || []
}

export const codigoStreaming = function (state) {
  return state.codigoStreaming || []
}

export const arquivoStreaming = function (state) {
  return state.arquivoStreaming || []
}

// spec-001 `plataforma-por-chat` — `{ stop_reason, usage, custo_brl }` do
// evento `finish`. Default `null`, nunca `undefined` (convenção da §9).
export const finishDoTurno = function (state) {
  return state.finishDoTurno || null
}

// spec-001 `preparacao-reuniao` — `{ versao, itens }` do evento `plano`.
// Default `null`, nunca `undefined` (convenção da §9).
export const planoDoTurno = function (state) {
  return state.planoDoTurno || null
}

// ── D6 (spec-010, [T028]) + RF-G2 — hub do turno e agentes da mensagem ─────
//
// Os cinco getters moram no slice COMPARTILHADO `hub-e-agente.js`, junto das
// actions que o `apiChat.js` despacha por namespace: as três superfícies de
// chat leem os mesmos nomes (`chat-message.badges.js` monta o badge com
// `storeModule + '/agentesDaMensagem'`). Reexportados aqui para quem já
// importava por nome — uma implementação, três composições.
export const hubDaConversa = hubEAgenteGetters.hubDaConversa
export const agentePorMensagem = hubEAgenteGetters.agentePorMensagem
export const agenteDaMensagem = hubEAgenteGetters.agenteDaMensagem
export const agentesDaMensagem = hubEAgenteGetters.agentesDaMensagem
export const agentesDoTurnoAoVivo = hubEAgenteGetters.agentesDoTurnoAoVivo
// spec-009 [T008] — o agente ativo ao lado do "Cliente em foco".
export const agenteAtualDaConversa = hubEAgenteGetters.agenteAtualDaConversa

// Default `null` (nunca `undefined`): a ausência de escopo é um estado
// legítimo — a conversa geral do escritório.
export const clienteEscopo = function (state) {
  return state.clienteEscopo || null
}

// spec-016 T035 — cliente resolvido pela IA (`abrir_cliente`) DENTRO da
// conversa corrente. Nome deliberadamente diferente da state key e da função
// utilitária `clienteDaConversa` (`utils/cliente-da-conversa.js`), para não
// colidir com o import que `view-chat.vue` já faz dela.
export const clienteDaConversaAtual = function (state) {
  return state.clienteDaConversa || null
}

// spec-009 [T006] — cliente fixado manualmente NESTA conversa. Default
// `null` (nunca `undefined`): ausência é o estado normal (a maioria das
// conversas não teve escolha manual de cliente).
export const clienteFixadoManualmente = function (state) {
  return state.clienteFixadoManualmente || null
}

// Régua ÚNICA de "o cliente desta conversa está
// travado por vínculo real" — antes vivia DUPLICADA (byte a byte) em
// `view-chat.vue::escopoTravado` e `ia-palette.vue::clienteTravadoPorVinculo`,
// cada uma lendo `selectedConversation`/`clienteFixadoManualmente` por conta
// própria. Duas cópias da mesma regra de negócio divergem sozinhas quando só
// uma é ajustada (foi exatamente o que aconteceu no bug do G-2/G-2 iterações
// anteriores) — daqui pra frente as duas telas chamam ESTE getter.
//
// Conversa que ainda não existe no banco (`selectedConversation` nulo/sem
// `.id`) nunca trava: o vínculo, se houver escolha, entra no INSERT — só
// depois de a conversa existir é que o PATCH grava a fixação manual (spec-009
// [T007]).
export const escopoClienteTravado = function (state) {
  const conv = state.selectedConversation
  if (!conv || !conv.id) return false
  const fixado = state.clienteFixadoManualmente
  return Boolean(fixado && fixado.conversation_id === conv.id)
}

// Insights da lateral imersiva — números do painel de situação do escritório.
// Default `[]`: coluna sem dado é estado legítimo (carregando ou erro), e um
// `undefined` aqui quebraria o `.filter` da view.
export const insights = function (state) {
  return state.insights || []
}
export const insightsLoading = function (state) {
  return state.insightsLoading
}
export const insightsError = function (state) {
  return state.insightsError
}
export const insightsLastUpdate = function (state) {
  return state.insightsLastUpdate
}

// Fila de curadoria para a faixa do composer. Default `null` (não `[]` nem
// `0`): a ausência de apuração é um estado legítimo e distinto de "fila vazia".
export const sugestoesATriar = function (state) {
  return state.sugestoesATriar
}
export const sugestoesATriarLoading = function (state) {
  return state.sugestoesATriarLoading
}

export const whatsappVinculo = function (state) {
  return state.whatsappVinculo
}

export const whatsappConectado = function (state) {
  return state.whatsappVinculo.status === 'ativo'
}
